import React, { Suspense, lazy } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { PageLoader } from "./components/PageLoader";
import "./App.css";

const IndustryPreviewPage = lazy(() => import("./pages/IndustryPreviewPage"));
const IndustryServicesPage = lazy(() => import("./pages/IndustryServicesPage"));
const IndustryReservePage = lazy(() => import("./pages/IndustryReservePage"));
const IndustryFaqPage = lazy(() => import("./pages/IndustryFaqPage"));
const IndustryGalleryPage = lazy(() => import("./pages/IndustryGalleryPage"));
const IndustryContactPage = lazy(() => import("./pages/IndustryContactPage"));
const AdminPage = lazy(() => import("./pages/AdminPage"));

const App = () => (
  <BrowserRouter>
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/nails/services" element={<Navigate to="/services" replace />} />
        <Route path="/nails" element={<Navigate to="/" replace />} />
        <Route path="/book" element={<Navigate to="/reserve" replace />} />
        <Route path="/services" element={<IndustryServicesPage />} />
        <Route path="/reserve" element={<IndustryReservePage />} />
        <Route path="/faq" element={<IndustryFaqPage />} />
        <Route path="/gallery" element={<IndustryGalleryPage />} />
        <Route path="/contact" element={<IndustryContactPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/" element={<IndustryPreviewPage />} />
      </Routes>
    </Suspense>
  </BrowserRouter>
);

export default App;
